if (!customElements.get('variation-buttons')) {
  customElements.define(
    'variation-buttons',
    class VariationButtons extends HTMLElement {
      constructor() {
        super();
    
        this.buttons = this.querySelector('.product__variant_buttons');
        this.productId = this.buttons.getAttribute('data-product-id');
        this.options0 = this.buttons.getAttribute('data-options-0');
        this.selectedTitle = this.buttons.getAttribute('data-selected-variant-title');
        this.layout = this.buttons.dataset.layout;
        this.setActiveButtons();
        this.setOptions();

        const varGroups = this.querySelectorAll('.vargroup');
        varGroups.forEach(varGroup => {
          //Get options within group
          const optionElements = varGroup.querySelectorAll('.varoption');
          optionElements.forEach(option => {
              option.addEventListener('click', () => {
                  // Pass options in group and selected option to click handler
                  this.clickHandler(optionElements, option);
              });
          });
        });
      }

      setActiveButtons(){
          if (this.options0 == "Bible Study Type"){
              this.template = "BIBLESTUDY";
              if (this.selectedTitle.includes("Precept Upon Precept")) {
                  this.bibleStudy = this.querySelector('#vo-pup-' + this.productId);
              } else {
                  this.bibleStudy = this.querySelector('#vo-io-' + this.productId);
              }
              if (this.selectedTitle.includes("NASB")){
                  this.bibleTranslation = this.querySelector('#vo-nasb-' + this.productId);
              } else {
                  this.bibleTranslation = this.querySelector('#vo-esv-' + this.productId);
              }
              this.bibleStudy.classList.add("active" );
              this.bibleTranslation.classList.add("active" );
          } else if (this.options0 == "Media Type"){
              this.template = "MEDIA";
              if (this.selectedTitle.includes("Streaming")) {
                  this.mediaType = this.querySelector('#vo-streaming-' + this.productId);
              } else if (this.selectedTitle.includes("DVD")) {
                  this.mediaType = this.querySelector('#vo-dvd-' + this.productId);
              } else if (this.selectedTitle.includes("CD")) {
                  this.mediaType = this.querySelector('#vo-cd-' + this.productId);
              } else if (this.selectedTitle.includes("MP3")) {
                  this.mediaType = this.querySelector('#vo-mp3-' + this.productId);
              }
              if (this.selectedTitle.includes("Kay")){
                  this.speaker = this.querySelector('#vo-kay-' + this.productId);
              } else if (this.selectedTitle.includes("David A")){
                  this.speaker = this.querySelector('#vo-david-a-' + this.productId);
              } else if (this.selectedTitle.includes("Pete D")){
                  this.speaker = this.querySelector('#vo-pete-' + this.productId);
              } else if (this.selectedTitle.includes("Wayne")){
                  this.speaker = this.querySelector('#vo-wayne-' + this.productId);
              } else if (this.selectedTitle.includes("David L")){
                  this.speaker = this.querySelector('#vo-david-l-' + this.productId);
              } else if (this.selectedTitle.includes("Bob V")){
                  this.speaker = this.querySelector('#vo-bob-' + this.productId);
              }
              this.mediaType.classList.add("active" );
              this.speaker.classList.add("active" );
          }
      }

      setOptions(){
          this.options = [];
          const optionDataEl = this.querySelectorAll('.variant-option');
          for (let i = 0; i < optionDataEl.length; i++) {
              const element = optionDataEl[i];
              const name = element.dataset.name;
              const id = element.dataset.id;
            if (this.template === "BIBLESTUDY"){
                  const bibleStudy = element.getAttribute('data-bible-study');
                  const translation = element.dataset.translation;
                  const level = element.dataset.level;
                  const option = {
                      name: name,
                      bible_study: bibleStudy,
                      translation: translation,
                      level: level,
                      id: id
                  }
                  this.options.push(option);
              } else if (this.template === "MEDIA"){
                  const mediaType = element.getAttribute('data-media-type');
                  const speaker = element.dataset.speaker;
                  const option = {
                      name: name,
                      media_type: mediaType,
                      speaker: speaker,
                      id: id
                  }
                  this.options.push(option);
              }
          }
      }
      clickHandler(optionElements, option){
          
          //remove active class from siblings
          optionElements.forEach(optionEl => {
              optionEl.classList.remove( "active" );
          });

          //add active class to clicked button
          option.classList.add( "active" );

          let variationSelectEl = document.querySelector("#product" + this.productId + "__form select[name='id']");
          let yourSelectionEl = document.querySelector('.your-selection-val');
          
          //Loop through options and identify correct selected index
          if (this.template == "BIBLESTUDY"){
              const bibleStudyValue = this.querySelector( ".bible-study-type button.active" ).dataset.value;
              const translationValue = this.querySelector( ".translation-type button.active" ).dataset.value
              for (let i = 0; i < this.options.length; i++) {
                  if (this.options[i].bible_study == bibleStudyValue && this.options[i].translation == translationValue){
                      //Set Select Value
                      variationSelectEl.value = this.options[i].id;
                      
                      if (this.layout == 'full'){
                        //Change Your Selection Text
                        yourSelectionEl.textContent = this.options[i].name+' (Level '+this.options[i].level +')';
                      }
                  }
              }
          } else if (this.template == "MEDIA"){
              const mediaValue = this.querySelector( ".media-type button.active" ).dataset.value;
              const speakerValue = this.querySelector( ".speaker-type button.active" ).dataset.value;
              for (let i = 0; i < this.options.length; i++) {
                  if (this.options[i].media_type == mediaValue && this.options[i].speaker == speakerValue){
                      //Set Select Value
                      variationSelectEl.value = this.options[i].id;

                      if (this.layout == 'full'){
                        //Change Your Selection Text
                        yourSelectionEl.textContent = this.options[i].name;
                      }
                  }
              }
          }

          const selectedVariant = variationSelectEl.querySelector('option:checked');

          // For main product, update main display elements
          if (this.layout == 'full'){
            const variantId = selectedVariant.value,
            variantPrice = selectedVariant.dataset.price,
            variantInventory = selectedVariant.dataset.inventory,
            variantInventoryColor = selectedVariant.getAttribute('data-inventory-color'),
            variantImageAlt = selectedVariant.getAttribute('data-image-alt'),
            variantMediaPostion = selectedVariant.getAttribute('data-media-position'),
            variantLookInsidePDF = selectedVariant.dataset.lookinsidepdf,
            variantUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?variant=' + variantId;

            let selectionMsg = document.getElementById("selection-msg");
            if (this.querySelector( ".media-type button.active" )){
              if (this.querySelector( ".media-type button.active" ).dataset.value == "DVD") {
              selectionMsg.textContent = "Please note: These DVDs are intended for traditional DVD players and may not play on computers or laptops.";
              } else {
              selectionMsg.textContent = "";
              }
            }

            if (variantLookInsidePDF == '') {
              document.querySelector('.look-inside-wrapper').classList.add('hide');
            } else {
              document.querySelector('.look-inside-wrapper a').setAttribute('href', variantLookInsidePDF);
              document.querySelector('.look-inside-wrapper').classList.remove('hide');
            }
            
            const timeEls = this.querySelectorAll('.variant-time')
            timeEls.forEach((timeEl) => {
              timeEl.classList.add('hide');
            });
            const selectedTimeEl = this.querySelector('.variant-time[data-id="'+variantId+'"]')
            if (selectedTimeEl){
              selectedTimeEl.classList.remove('hide');
            }

            const hideSpecDetailEls = document.querySelectorAll('.variant-spec-details');
            hideSpecDetailEls.forEach((specDetailEl) => {
              specDetailEl.classList.add('hide');
            });
            
            const activeSpecDetailEls = document.querySelectorAll('.variant-spec-details[data-id="'+variantId+'"]');
            activeSpecDetailEls.forEach((specDetailEl) => {
              specDetailEl.classList.remove('hide');
            });
            
            document.querySelector('.product__form .product__buy .variant__price').textContent = variantPrice;
            const inventoryEl = document.querySelector('.variant-inventory');
            if (inventoryEl){
              inventoryEl.textContent = variantInventory;
              inventoryEl.classList.remove('red');
              if(variantInventoryColor){
                inventoryEl.classList.add(variantInventoryColor);
              }
            }
            
            
            //Slick Slider only works with Jquery
            $(function() {
              //filter images
              $('.product__thumbnails li.product__thumbnail').hide();
              $('.product__thumbnails li.product__thumbnail[data-image-alt*="Hero"').show();
              $('.product__thumbnails li.product__thumbnail[data-image-alt="' + variantImageAlt+ '"]').show();
              $('.product__thumbnails li.product__thumbnail[data-image-alt*="General"').show();
              $('.product__thumbnails li.product__thumbnail[data-image-alt*="Video"').show();

              //Filter Slides
              $('.product__slideshow').slick('slickUnfilter');
              $('.product__slideshow li.slick-slide').removeClass('filter');
              $('.product__slideshow li.slick-slide[data-image-alt*="Hero"').addClass('filter');
              $('.product__slideshow li.slick-slide[data-image-alt="' + variantImageAlt + '"]').addClass('filter');
              $('.product__slideshow li.slick-slide[data-image-alt*="General"').addClass('filter');
              $('.product__slideshow li.slick-slide[data-image-alt*="Video"').addClass('filter');
              $('.product__slideshow').slick('slickFilter','.filter');

              //Pause any playing videos
              let allVideos = document.querySelectorAll('video');
              allVideos.forEach(v=>v.pause()); 

              //Update Slideshow
              $('.product__thumbnails li.product__thumbnail[data-index="' + (variantMediaPostion - 1) + '"]').click();
            });

            //Update history
            window.history.pushState({ path: variantUrl }, '', variantUrl);
          } else if (this.layout == 'compact'){
            const variantPrice = selectedVariant.dataset.price;
            document.querySelector('#product' + this.productId + '__form .product__buy .variant__price').textContent = variantPrice;
          }
      }
    }
  );
}
